module.exports = __webpack_public_path__ + "static/media/01.22d1ec1b.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/components/HeaderBar/img/01.jpg
// module id = 793
// module chunks = 33